import { ICareMapNoteTarget } from './model/ICareMapNoteTarget';
import { EditNoteUsingCareMapDrawer } from './edit-note/EditNoteUsingCareMapDrawer';
import { AddNoteUsingCareMapDrawer } from './add-note/AddNoteUsingCareMapDrawer';

export const AddOrEditNoteUsingCareMapDrawer: React.FC<{noteId?: string; defaultNoteTarget: ICareMapNoteTarget}> = ({ noteId, defaultNoteTarget }) => {
    if (!noteId){
        return <AddNoteUsingCareMapDrawer noteTarget={defaultNoteTarget} />;
    }
    else {
        return <EditNoteUsingCareMapDrawer noteId={noteId} />;
    }
};
